import { FileEarmarkImageFill } from 'react-bootstrap-icons';

interface ImageContainerProps {
    img_url: string;
}

function ImageContainer({img_url}: ImageContainerProps){
    const altDescription = ""
    return (
        /* Need to write code to capture half stars */
        <> 
            {img_url ? <img alt={altDescription} className="square-image-block" src={img_url} /> : <div className="style-center-child"><div><FileEarmarkImageFill className="square-image-block color-font-primary" size={40} /></div></div> }
        </>
    )
}

export default ImageContainer;